export default __webpack_public_path__ + "static/media/muttonkebab.4bc5f734.jpg";